import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const LONGHORN_DEVICE_ID = 'LONGHORN_DEVICE_ID';

let DEVICE_ID: string = localStorage.getItem(LONGHORN_DEVICE_ID) || '';

export const triggerFingerprintJS = async () => {
  const analyticsData = {
    eventName: 'FingerPrintJS',
    attributes: {
      fingerPrintBeforeFetch: Date.now(),
      fingerPrintFetched: -1
    }
  } as any;

  const fpPromise = FingerprintJS.load({
    monitoring: false
  });

  if (!DEVICE_ID) {
    const fp = await fpPromise;
    const result = await fp.get();
    const newDeviceId = result.visitorId;
    analyticsData.fingerPrintFetched = Date.now();
    setDeviceId(newDeviceId);
    return newDeviceId;

    // logError(new Error('LOG_TEST_FP'), JSON.stringify(analyticsData));
    // navigator?.sendBeacon('/events/json', analyticsData)
  }
  return DEVICE_ID;
};

export const getDeviceId = (): string => {
  if (!DEVICE_ID) {
    triggerFingerprintJS();
  }
  return DEVICE_ID;
};

export const setDeviceId = (deviceId: string) => {
  if (!deviceId) return;

  DEVICE_ID = deviceId;
  localStorage.setItem(LONGHORN_DEVICE_ID, deviceId);
};

export const resetDeviceId = () => {
  DEVICE_ID = '';
  localStorage.setItem(LONGHORN_DEVICE_ID, DEVICE_ID);
};
